<template>
  <div>
  <v-card>
    <v-toolbar dark color="blue-grey white--text">
      <!-- <v-icon>contacts</v-icon> -->
      <v-toolbar-title class="white--text">บุคคล</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        append-icon="search"
        label="ค้นหา ชื่อ, นามสกุล"
        single-line
        hide-details
        v-model="pagination.q"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-tooltip left v-if="hasAccess(allowedRoles)">
        <v-btn color="teal" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่มบุคคล</span>
      </v-tooltip>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      hide-actions
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
        <td>{{ props.item.personName.fullnameTh }}</td>
        <td>{{ props.item.personName.fullnameEn }}</td>
        <td>{{ props.item.personTypeName }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip left>
            <v-btn icon class="mx-0" slot="activator" @click="viewItem(props.item)">
              <v-icon color="teal">pageview</v-icon>
            </v-btn>
            <span>ดูข้อมูล</span>
          </v-tooltip>
          <!-- <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn> -->
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ pagination.q }}" found no results.
      </v-alert>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination :length="Math.ceil(pagination.totalItems / pagination.rowsPerPage)" v-model="pagination.page" :total-visible="7"></v-pagination>
    </div>
    
    <component :is="formDialog" :dialog="dialog" @dialog="dialog = $event"></component>
  </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'
import FormDialog from './forms/formDialog'

export default {
  mixins: [ hasAccessMixin ],
  components: {
    FormDialog
  },
  data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      dialog: false,
      loading: false,
      search: '',
      headers: [
        { text: '#', sortable: false, align: 'center', width: '10'},
        { text: 'ชื่อไทย', value: 'personName.fullnameTh' },
        { text: 'ชื่ออังกฤษ', value: 'personName.fullnameEn' },
        { text: 'ประเภท', value: 'personTypeName' },
        { sortable: false}
      ],
      pagination: {
        q: '',
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All
        sortBy: 'personName',
        totalItems: 0
      },
      items: [],
      selectedItem: {},
      formDialog: null
    }
  },
  mounted () {
    // console.log('mounted....')
    this.$store.dispatch('university/fetchCampus')
    this.$store.dispatch('university/fetchFaculties')
    this.$store.dispatch('person/loadEducationLevelItems')
    this.$store.dispatch('personType/loadPersonTypeItems')
    // this.reload()
  },
  computed: {
    ...mapGetters([
      'personItems',
      'token'
    ])
  },
  methods: {
    hasAccess (allowedRoles) {
      if (!allowedRoles || allowedRoles.length === 0) {
        return true
      }
      return this.roles.filter(function (value) {
        return allowedRoles.indexOf(value) > -1
      }).length > 0
    },
    addItem () {
      // console.log('addItem')
      this.formDialog = 'form-dialog'
      setTimeout(()=>{this.dialog = true}, 500)
    },
    viewItem (item) {
      // console.log('viewItem', item)
      this.$router.push({ name: 'personShow', params: { personId: item.id }})
    },
    reload () {
      // console.log('reload called...')
      // const { q, sortBy, descending, page, rowsPerPage } = this.pagination
      this.loading = true
      this.$store.dispatch("person/loadItemsAsPage", this.pagination)
        .then((response) => {
          // console.log('page in response ->', this.pagination.page)
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
        }).catch((error)=>{
          // console.log('reload', error)
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    }
  },
  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    },
    /*'pagination.rowsPerPage' () {
      console.log('pagination.rowsPerPage called...')
      this.reload()
    },
    'pagination.q' () {
      console.log('pagination.q called...')
      this.reload()
    },
    'pagination.page' () {
      console.log('pagination.page called...', this.pagination.page)
      this.reload()
    },
    'pagination.descending' () {
      console.log('pagination.descending called...')
      this.reload()
    },*/
    dialog (val) {
      if(!val) {
        setTimeout(()=>{
          this.formDialog = null
        }, 300)
        this.reload()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/person/index.vue